import React, { useEffect } from 'react';
import { useWidgetConfig } from '@/hooks/useWidgetConfig';
import { applyTheme } from '@/config/theme.config';
import { Header } from './Header';
import { StepIndicator } from './StepIndicator';
import { useLeadStore } from '@/store/useLeadStore';

interface WidgetContainerProps {
  children: React.ReactNode;
}

export const WidgetContainer: React.FC<WidgetContainerProps> = ({ children }) => {
  const config = useWidgetConfig();
  const { currentStep } = useLeadStore();

  useEffect(() => {
    applyTheme(config);
  }, [config]);

  // Don't show step indicator on success page (step 6)
  const showStepIndicator = currentStep <= 5;

  return (
    <div className="bg-background w-full max-w-[520px] border border-border relative">
      <div className="p-8 pb-6 border-b border-border">
        <Header logoText={config.logoText} logoUrl={config.logoUrl} />
        {showStepIndicator && (
          <StepIndicator currentStep={currentStep} totalSteps={5} />
        )}
      </div>
      <div className="p-10 min-h-[450px] relative overflow-hidden">
        {children}
      </div>
    </div>
  );
};
